import styled from "styled-components";
import { colors } from "../constants";

export default styled.div`
    height: 1px;
    width: 100%;
    background-color: ${colors.mediumTeal};
`;
